import axios from "axios";
import { SessionStorage } from "@belray-ventec/platform-session";

import { API_URL } from "@/config";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const authToken = SessionStorage.get()?.authToken;
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

export function setAxiosAuth({ authToken }: { authToken: string }) {
  api.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
}

export default api;
